import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../ApiConfig/ApiConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUser,
  faLock,
  faEye,
  faEyeSlash,
  faEnvelope,
  faPhoneAlt,
  faMapMarkerAlt,
} from '@fortawesome/free-solid-svg-icons';


function Register() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    password: '',
    role: '', // Default role
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();


    try {
      const response = await fetch(`${API_BASE_URL}/api/users/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });


      if (response.ok) {
        alert('User registered successfully!');
        navigate('/');
      } else {
        const result = await response.json();
        setError(result.error);
      }
    } catch (error) {
      console.error('Error:', error);
      setError('An error occurred. Please try again later.');
    }
  };


  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };


  return (
    <div className="flex items-center justify-center min-h-screen bg-[#FAF9FF] flex-col px-4 lg:px-0">
      <div className="flex flex-col lg:flex-row bg-white shadow-lg overflow-hidden w-full lg:w-10/12 max-w-4xl rounded-2xl">
        
        {/* Left Section with Image - Hidden on mobile */}
        <div className="hidden lg:flex justify-center items-center w-full lg:w-1/2 bg-white overflow-hidden rounded-t-2xl lg:rounded-s-2xl">
          <img src="/auth-page-images/bg.svg" alt="Illustration" className="w-full h-full object-cover" />
        </div>


        {/* Right Section with Form */}
        <div className="w-full lg:w-[45%] p-6 lg:p-6 rounded-b-2xl lg:rounded-e-2xl">
          {error && <p className="text-red-500 text-center">{error}</p>}
          <img src="/auth-page-images/securent 1.svg" alt="SecureNet Logo" className="mx-auto h-7" />


          <form onSubmit={handleSubmit} className="pt-7">
            {[
              { name: 'name', placeholder: 'Full Name', icon: faUser },
              { name: 'email', placeholder: 'Email', icon: faEnvelope, type: 'email' },
              { name: 'phone', placeholder: 'Phone Number', icon: faPhoneAlt, type: 'tel' },
              { name: 'address', placeholder: 'Address', icon: faMapMarkerAlt },
              {
                name: 'password',
                placeholder: 'Password',
                icon: faLock,
                type: showPassword ? 'text' : 'password',
              },
            ].map(({ name, placeholder, icon, type = 'text' }) => (
              <div className="mb-6 relative" key={name}>
                <input
                  type={type}
                  name={name}
                  className="w-full p-[4px] pl-10 text-[#1C50A3] rounded-lg bg-[#E2EDFF80] focus:outline-none focus:ring-2 focus:ring-[#1C50A3] text-lg font-medium placeholder:text-[#1C50A3]"
                  value={formData[name]}
                  onChange={handleInputChange}
                  placeholder={placeholder}
                  autoComplete={name === 'password' ? 'new-password' : name}
                />
                <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-[#1C50A3]">
                  <FontAwesomeIcon icon={icon} className={name === 'phone' ? 'rotate-90' : ''} />
                </span>
                {name === 'password' && (
                  <span
                    className="absolute inset-y-0 right-0 pr-4 mt-1 flex items-center cursor-pointer text-[#1C50A3]"
                    onClick={togglePasswordVisibility}
                  >
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                  </span>
                )}
              </div>
            ))}


            <div className="mb-6 relative">
              <select
                id="role"
                name="role"
                value={formData.role}
                onChange={handleInputChange}
                className="w-full p-[4px] pl-3 rounded-lg bg-[#E2EDFF80] text-[#1C50A3] focus:outline-none focus:ring-2 focus:ring-[#1C50A3] text-lg font-semibold appearance-none pr-10"
              >
                <option value="">Select Role</option> {/* Placeholder */}
                <option value="User">User</option>
                <option value="Dealer">Dealer</option>
              </select>
              <span className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                <svg className="w-6 h-6 text-[#1C50A3]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </span>
            </div>


            <button
              type="submit"
              className="w-full bg-[#1C50A3] text-white p-1 rounded-lg transition duration-200 text-lg font-bold"
            >
              Register
            </button>
          </form>


          <div className="mt-2 text-center">
            <span className="text-gray-600 text-sm">Already have an account?</span>
            <Link to="/" className="text-[#1C50A3] font-bold ml-2 hover:underline">
              Login
            </Link>
          </div>
        </div>
      </div>


      <footer className="mt-4 text-center text-gray-600 text-sm px-4">
        <p>© 2025 Securenet India. All Rights Reserved.</p>
        <p>
          Developed by{" "}
          <a
            href="https://creativestudio24.in"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Creative Studio 24
          </a>
        </p>
      </footer>


    </div>


  );
}


export default Register;
